// * Components
import Hero from "./components/Hero";
import Reviews from "./components/Reviews";
import Guide from './components/Guide'
import Properties from "./components/Properties";
import MoreDetail from "./components/MoreDetail";
import Featured from "./components/Featured";
import Footer from "./components/Footer";


function App() {

  return (
    <div className="App">
      <Hero />
      <Reviews />
      <Guide />
      <Properties />
      <MoreDetail />
      <Featured />
      <Footer />
    </div>
  );
}

// Git debug comment

export default App;
